import { createContext, ReactNode, useContext } from 'react'
import { EditsEvent, ActivityEventContext } from 'components/ActivityEvent/Types'
import { TimelineEvent } from 'screens/Activity/Types'

interface TimelineProviderProps {
  children: ReactNode
  event?: TimelineEvent
  nestedEvent?: EditsEvent
  onSelectEvent: (event: TimelineEvent) => void
  actionsEnabled?: boolean
  disabledEventId?: string
  context?: ActivityEventContext
}

interface ActivityTimelineContextState {
  context: ActivityEventContext
  event: TimelineEvent | undefined
  nestedEvent: EditsEvent | undefined
  actionsEnabled: boolean
  disabledEventId?: string
}

interface ActivityTimelineContextMethods {
  onSelectEvent: (event: TimelineEvent) => void
}

interface ActivityTimelineContextValue extends ActivityTimelineContextState, ActivityTimelineContextMethods {}

const ActivityTimelineContext = createContext<ActivityTimelineContextValue>({
  event: undefined,
  nestedEvent: undefined,
  onSelectEvent: () => {},
  actionsEnabled: true,
  context: 'activity',
})

const ActivityTimelineContextProvider = ActivityTimelineContext.Provider

export const ActivityTimelineProvider = ({
  children,
  event,
  nestedEvent,
  onSelectEvent,
  actionsEnabled = true,
  disabledEventId,
  context = 'activity',
}: TimelineProviderProps) => {
  const value: ActivityTimelineContextValue = {
    event,
    nestedEvent,
    context,
    onSelectEvent,
    actionsEnabled,
    disabledEventId,
  }

  return <ActivityTimelineContextProvider value={value}>{children}</ActivityTimelineContextProvider>
}

export const useActivityTimelineContext = () => {
  return useContext(ActivityTimelineContext)
}
